/**
 * The learner's calendar day as YYYY-MM-DD in this browser's time zone. Since migration 81
 * the server computes "today" in users.timezone, which the app sets from this same browser
 * (set_my_timezone), so client-side day checks must use local dates, not UTC.
 */
export function localDateString(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** IANA time zone of this browser, e.g. "America/Los_Angeles". */
export function browserTimeZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}
